<tt-page>
    <tt-page-heading>{{ heading }}</tt-page-heading>
    <tt-documents [params]="params" (getLoaded)="heading = $event.page_heading"></tt-documents>
</tt-page>
